export default __webpack_public_path__ + "static/media/IT_CHANNEL.a0d7bd34.png";